(function () {
  // 1) Force hide Sobefy accessories modal
  const style = document.createElement('style');
  style.textContent = `
    #sobefy__accesories-upsell-modal-popup,
    #sobefy__accesories-upsell-modal {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
    }
  `;
  document.head.appendChild(style);

  // 2) Handle redirect AFTER add-to-cart happens
  document.addEventListener('product:added', function (event) {
    const lightboxContainer = document.getElementById("sobefy__accesories-upsell-modal");
    const popupModal = document.getElementById("sobefy__accesories-upsell-modal-popup");

    if (lightboxContainer) {
      lightboxContainer.style.display = "none";
      lightboxContainer.style.visibility = "hidden";
      lightboxContainer.style.opacity = "0";
    }

    if (popupModal) {
      popupModal.style.display = "none";
      popupModal.style.visibility = "hidden";
      popupModal.style.opacity = "0";
    }

    var context = window.__lastAddToCartContext || null;
    if (context && context.expires <= Date.now()) {
      window.__lastAddToCartContext = null;
      context = null;
    }

    // If item added from accessories or sample -> don't redirect
    var isFromAccessories = false;
    var isFromSample = false;

    if (event.detail && event.detail.fromAccessories === true) {
      isFromAccessories = true;
    } else if (event.detail && event.detail.button) {
      var b1 = event.detail.button;
      if (b1.closest && b1.closest('.accessories_upsell')) isFromAccessories = true;
    } else if (context && context.preventRedirect) {
      isFromAccessories = true;
    }

    if (event.detail && event.detail.fromSample === true) {
      isFromSample = true;
    } else if (event.detail && event.detail.button) {
      var b2 = event.detail.button;
      if (b2.hasAttribute && (b2.hasAttribute('data-is-sample') || b2.hasAttribute('data-sample-order'))) {
        isFromSample = true;
      }
    } else if (window.__isSampleOrder === true || window.__preventCartRedirect === true) {
      isFromSample = true;
    }

    if (isFromAccessories || isFromSample) {
      window.__lastAddToCartBtn = null;
      window.__isSampleOrder = false;
      window.__preventCartRedirect = false;
      return;
    }

    // Don't redirect if already on pre-cart page
    var href = window.location.href;
    var alreadyOnAddedPage =
      href.indexOf('/pages/add-to-cart') !== -1 ||
      href.indexOf('view=added-to-cart') !== -1;

    if (alreadyOnAddedPage) return;

    // ✅ Routing decision based on dataset printed by Liquid
    var btn = event.detail && event.detail.button ? event.detail.button : null;

    var withAccessoriesUrl = '/pages/add-to-cart?view=added-to-cart';
    var noAccessoriesUrl = '/cart';

    if (btn && btn.dataset) {
      if (btn.dataset.redirectWithAccessories) withAccessoriesUrl = btn.dataset.redirectWithAccessories;
      if (btn.dataset.redirectNoAccessories) noAccessoriesUrl = btn.dataset.redirectNoAccessories;
    }

    // IMPORTANT: Default should be "false" to avoid always going to pre-cart
    var hasAccessories = false;
    if (btn && btn.dataset && typeof btn.dataset.hasAccessories !== 'undefined') {
      hasAccessories = (btn.dataset.hasAccessories === 'true');
    }

    window.location.href = hasAccessories ? withAccessoriesUrl : noAccessoriesUrl;
  });

  // 3) Intercept clicks and add via AJAX, then trigger product:added
  document.addEventListener('click', function (e) {
    var btn = e.target.closest(
      'button.product-form__add-button[data-action="add-to-cart"], button.product-item__action-button[data-action="add-to-cart"]'
    );
    if (!btn) return;

    var form = btn.closest('form');
    if (!form) return;

    var idInput = form.querySelector('input[name="id"]');
    var quantityInput = form.querySelector('[name="quantity"]');

    var variantId = idInput && idInput.value ? Number(idInput.value) : null;
    var quantity = Math.max(1, parseInt((quantityInput && quantityInput.value) || '1', 10) || 1);

    if (!variantId || !isFinite(variantId)) return;

    var isFromAccessories = !!btn.closest('.accessories_upsell');

    var isFromSample =
      btn.hasAttribute('data-is-sample') ||
      btn.hasAttribute('data-sample-order') ||
      window.__isSampleOrder === true ||
      window.__preventCartRedirect === true;

    var context = {
      preventRedirect: isFromAccessories || isFromSample,
      expires: Date.now() + 5000
    };

    window.__lastAddToCartBtn = btn;
    window.__lastAddToCartContext = context;

    if (window.__lastAddToCartContextCleanupTimer) clearTimeout(window.__lastAddToCartContextCleanupTimer);
    window.__lastAddToCartContextCleanupTimer = setTimeout(function () {
      window.__lastAddToCartContext = null;
    }, 5000);

    e.preventDefault();
    e.stopPropagation();

    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (j) { throw j; });
        return res.json();
      })
      .then(function (payload) {
        btn.textContent = 'Added';
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 800);

        if (context && payload && payload.product_id) {
          context.variant = payload;
        }

        document.documentElement.dispatchEvent(
          new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              quantity: quantity,
              variant: payload,
              button: btn,
              fromAccessories: isFromAccessories,
              fromSample: isFromSample
            }
          })
        );
      })
      .catch(function () {
        btn.textContent = 'Try again';
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1200);

        window.__lastAddToCartContext = null;
        window.__lastAddToCartBtn = null;
      });
  });
})();

(function () {

  function initInstallerButtons() {

    const buttons = document.querySelectorAll('button');

    let yesBtn = null;
    let noBtn = null;

    buttons.forEach(btn => {
      const text = btn.innerText.trim().toLowerCase();

      if (text === "yes") yesBtn = btn;
      if (text === "no") noBtn = btn;
    });

    if (!yesBtn || !noBtn) {
      console.log("Installer buttons not found yet...");
      return false;
    }

    console.log("Installer buttons found ✅");

    async function updateDraftOrderTags(tagSelected) {
      try {
        const params = new URLSearchParams(window.location.search);
        const orderId = params.get("order_id");

        if (!orderId) {
          console.error("Order ID missing");
          return false;
        }

        const res = await fetch("https://us-central1-floor-city-request-quote.cloudfunctions.net/update-draft-order-tags", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            id: orderId,
            tagSelected
          })
        });

        const data = await res.json();
        console.log("Tag response:", data);

        return res.ok;

      } catch (err) {
        console.error(err);
        return false;
      }
    }

    yesBtn.addEventListener('click', async () => {
      console.log("YES CLICKED");

      const ok = await updateDraftOrderTags('yes_installer');

      if (!ok) return alert("Error");

      await fetch('/cart/clear.js', { method: 'POST' });
      window.location.href = '/a/review/all';
    });

    noBtn.addEventListener('click', async () => {
      console.log("NO CLICKED");

      const ok = await updateDraftOrderTags('no_installer');

      if (!ok) return alert("Error");

      await fetch('/cart/clear.js', { method: 'POST' });
      window.location.href = '/';
    });

    return true;
  }

  let attempts = 0;
  const interval = setInterval(() => {
    attempts++;

    if (initInstallerButtons() || attempts > 20) {
      clearInterval(interval);
    }
  }, 500);

})();